import $ from "jquery";

$(document).ready(function () {

  $('.nav-menu__item').click(function () {
    $(this).toggleClass('js-subnav-open');
  });

});
